export const FontFamilyPreset = {
	openSans: "Open Sans Variable",
	inter: "Inter Variable",
};

export const typographyTokens = {
	fontFamily: {
		openSans: FontFamilyPreset.openSans,
		inter: FontFamilyPreset.inter,
	},
	fontSize: {
		xs: "12px",
		sm: "14px",
		default: "16px",
		lg: "18px",
		xl: "20px",
		"2xl": "24px",
		"3xl": "32px",
	},
	fontWeight: {
		light: "300",
		normal: "400",
		medium: "500",
		semibold: "600",
		bold: "700",
	},
	lineHeight: {
		none: "1",
		tight: "1.25",
		normal: "1.375",
		relaxed: "1.5",
	},
};
